import { FunctionalComponent, h } from '@stencil/core';

export const Frame: FunctionalComponent = ({}, children) => (
  <div
    class="
      frame
      col
      fixed
      inset--0
      align--center-v
    "
  >{children}</div>
);
